import type { PolymorphicRef } from '@sds-system/types';
import type { ElementType } from 'react';
import { forwardRef } from 'react';
import { StyledIconButton } from './IconButton.styled';
import type { IconButtonComponent, IconButtonProps } from './IconButton.types';

export const IconButton: IconButtonComponent = forwardRef(
  <C extends ElementType = 'button'>(
    {
      children,
      variant = 'solid.primary',
      isRound = false,
      size = 'M',
      ...props
    }: IconButtonProps<C>,
    ref: PolymorphicRef<C>,
  ) => {
    return (
      <StyledIconButton isRound={isRound} ref={ref} size={size} variant={variant} {...props}>
        {children}
      </StyledIconButton>
    );
  },
);
